module.exports = __webpack_public_path__ + "static/profile-2ffbd5a3e86d649c3a53a5593d7ff134.jpeg";